<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="类型">
            <a-select
              v-decorator="['type_value']"
              allow-clear
              :loading="loadingCommonTypeTypeOptions"
              @focus="fetchCommonTypeTypeOptions"
            >
              <a-select-option
                v-for="option in commonTypeTypeOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="4">
          <a-form-item label="状态">
            <a-select
              v-decorator="['effective', { initialValue: '1' }]"
              allow-clear
            >
              <a-select-option key="1" value="1">
                有效
              </a-select-option>
              <a-select-option key="0" value="0">
                无效
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="5">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
import { findCommonTypeTypeOptions } from '@/api/common_type'

export default {
  name: 'SearchCommonType',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'common_type_search' }),
      loadingCommonTypeTypeOptions: false,
      commonTypeTypeOptions: [],
      commonTypeTypeOptionsMap: {}
    }
  },
  methods: {
    // 加载通用类型选项
    fetchCommonTypeTypeOptions() {
      this.loadingCommonTypeTypeOptions = true
      findCommonTypeTypeOptions().then((res) => {
        if (res.code === 0) {
          this.commonTypeTypeOptions = res.data
          res.data.forEach((element) => {
            this.commonTypeTypeOptionsMap[element.id] = element
          })
        }
        this.loadingCommonTypeTypeOptions = false
      })
    },

    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.form.getFieldsValue())
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
